import { inject, InjectionToken, PLATFORM_ID } from '@angular/core';
import { EnvironmentType } from '@src/app/models/environment.type';
import { environment } from '@src/environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { MockSessionStorage } from '@src/app/providers/mock-session-storage';

export const WINDOW = new InjectionToken<Window>('window', {
  providedIn: 'root',
  factory: () => window,
});

export const NAVIGATOR = new InjectionToken<Navigator>('navigator', {
  providedIn: 'root',
  factory: () => inject(WINDOW)?.navigator,
});

export const LOCATION = new InjectionToken<Location | null>('LocationToken', {
  providedIn: 'root',
  factory: () => (typeof window !== 'undefined' ? window.location : null),
});

export const ENVIRONMENT = new InjectionToken<EnvironmentType>('environment', {
  providedIn: 'root',
  factory: () => environment,
});

export const SESSION_STORAGE = new InjectionToken<Storage>('SessionStorageToken', {
  providedIn: 'root',
  factory: () => {
    const platform = inject(PLATFORM_ID);
    if (isPlatformBrowser(platform)) {
      return window.sessionStorage;
    } else {
      return new MockSessionStorage();
    }
  },
});

export const LOCAL_STORAGE = new InjectionToken<Storage>('LocalStorageToken', {
  providedIn: 'root',
  factory: () => {
    const platform = inject(PLATFORM_ID);
    if (isPlatformBrowser(platform)) {
      return window.localStorage;
    } else {
      return new MockSessionStorage();
    }
  },
});
